import { ConsentForm } from "@/modules/login/ConsentForm.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/consent_form")({
    component: ConsentForm,
});
